import BusinessLayout from '../../components/business/BusinessLayout';
import Breadcrumb from '../../components/common/Breadcrumb';

const BusinessSettingsPage = () => {
  return (
    <BusinessLayout title="Settings">
      <Breadcrumb 
        items={[
          { label: 'Dashboard', href: '/business/dashboard' },
          { label: 'Settings', href: '/business/settings' }
        ]} 
      />

      <div className="max-w-2xl">
        <div className="bg-white rounded-xl border border-slate-200 p-8">
          <h2 className="text-[20px] font-bold text-slate-900 mb-2">Settings</h2>
          <p className="text-[13px] text-slate-600 mb-8">
            Coming soon! Manage your notification preferences, business hours, and more.
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 mb-4">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2">
                <circle cx="12" cy="12" r="3" />
                <path d="M12 1v6m0 6v6M4.22 4.22l4.24 4.24m2.12 2.12l4.24 4.24M1 12h6m6 0h6m-17.78 7.78l4.24-4.24m2.12-2.12l4.24-4.24" />
              </svg>
            </div>
            <p className="text-[13px] text-blue-700 font-medium">
              Settings management features coming in the next update
            </p>
          </div>
        </div>
      </div>
    </BusinessLayout>
  );
};

export default BusinessSettingsPage;
